export const RESOURCESURL = process.env.NODE_ENV === 'production'
  ? 'https://www.dodo.it/r/uniqon-resources'
  : 'http://localhost:8095'
